export default "__VITE_ASSET__F2A2Ch0t__"